import React, { useState, useEffect } from 'react';
import InputMask from 'react-input-mask';
import ReactSelect from 'react-select';
import { useEntityCrud } from '../../hooks/useEntityCrud';
import Pagination from '../Common/Pagination';
import { toast } from 'react-toastify';
import DatePicker from '@hassanmojab/react-modern-calendar-datepicker';
import moment from 'moment-jalali';

const pageItemsShow = [
    {
        value: 10,
        label: "10"
    }, {
        value: 20,
        label: "20"
    }, {
        value: 50,
        label: "50"
    }, {
        value: 100,
        label: "100"
    },
]



const Transactions = () => {

    const convertToGregorian = date => date.year.toString() + (date.month > 9 ? date.month.toString() : ('0' + date.month)) + (date.day > 9 ? date.day.toString() : ('0' + date.day))

    const { readData } = useEntityCrud('Report/geGeneralReport');
    const [globalFilters, setGlobalFilters] = useState({});
    const [pages, setPages] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [rows, setRows] = useState([]);
    const [count, setCount] = useState(0);
    const [isSearched, setIsSearched] = useState(false);
    const [businessId, setBusinessId] = useState(0);
    const [groupId, setGroupId] = useState(0);
    const [serviceId, setServiceId] = useState(0);
    const [userId, setUserId] = useState(0);
    const [personTypeId, setPersonTypeId] = useState(0);
    const [nationalCode, setNationalCode] = useState('');
    const [consumingNationalCode, setConsumingNationalCode] = useState('');
    const [fromDate, setFromDate] = useState();
    const [toDate, setToDate] = useState();
    const [status, setStatus] = useState('');
    const [businesses, setBusinesses] = useState([]);
    const { readData: getBusiness } = useEntityCrud('Business/GetAllBusiness');
    const { readData: getUsers } = useEntityCrud('User/GetAllUsers');
    const { readData: getPersonnelTypes } = useEntityCrud('PersonType/GetAllPersonTypes');
    const [users, setUsers] = useState([]);
    const [personTypes, setPersonTypes] = useState([]);
    const [groups, setGroups] = useState([]);
    const { readData: getGroups } = useEntityCrud('Group/GetAllGroups?buisnessId=' + businessId);
    const [services, setServices] = useState([]);
    const { readData: getServices } = useEntityCrud('Service/GetAllServices?groupId=' + groupId);

    const [isAdvanced, setIsAdvanced] = useState(false);
    const [isLoading, setLoading] = useState(false);
    const [showItem, setShowItem] = useState(true);


    const [pageItems, setPageItems] = useState(0);


    useEffect(() => {
         
        showMore(pageItems)
    }, [pageItems])


    useEffect(() => {
        getBusiness().then(({ data }) => {
            let businesses = [];
            if (data.status)
                data.result.map(item => {
                    // if (item.isActive) {
                        if (!(businesses?.find(it => it.label === item.title))) {
                            businesses.push({
                                label: item.title,
                                value: item.id
                            });
                        }
                    // }
                })
            setBusinesses(businesses);
        })
        getUsers().then(({ data }) => {
            let gUsers = [];
            if (data.status)
                data.result.map(item => {
                    if (item.isActive)
                        gUsers.push({
                            label: item.firstName + ' ' + item.lastName + ' - ' + item.nationalCode,
                            value: item.nationalCode
                        });
                })
            setUsers(gUsers);
        })
        getPersonnelTypes().then(({ data }) => {
            let gPersonTypes = [];
             if (data.status)
                data.result.map(item => {
                    gPersonTypes.push({
                        label: item.title,
                        value: item.id
                    });
                })
            setPersonTypes(gPersonTypes);
        })
    }, [])

    useEffect(() => {
        if (businessId)
            getGroups().then(({ data }) => {
                let groups = [];
                if (data.status)
                    data.result.map(item => {
                        if (item.isActive)
                            groups.push({
                                label: item.title,
                                value: item.id
                            });
                    })
                setGroups(groups);
            });
    }, [businessId])

    useEffect(() => {
        if (groupId)
            getServices().then(({ data }) => {
                let services = [];
                if (data.status)
                    data.result.map(item => {
                        if (item.isActive)
                            services.push({
                                label: item.title,
                                value: item.id
                            });
                    })
                setServices(services);
            });
    }, [groupId])

    useEffect(() => {
        const filters = {};
        if (nationalCode)
            filters.p_nationalcode = nationalCode;
        if (groupId)
            filters.p_group = groupId;
        if (businessId)
            filters.p_business = businessId.toString();
        if (serviceId)
            filters.p_service = serviceId;
        if (status)
            filters.p_status = status == 1 ? 1 : 0;
        if (userId) {
            filters.p_username = userId;
        }
        if (consumingNationalCode)
            filters.p_consumer_nationalcode = consumingNationalCode;
        if (personTypeId)
            filters.p_persontype = personTypeId;
        if (fromDate)
            filters.from_date = convertToGregorian(fromDate)
        if (toDate)
            filters.to_date = convertToGregorian(toDate)
        console.log(personTypeId, userId, consumingNationalCode);
        setGlobalFilters(filters);
    }, [nationalCode, groupId, businessId, serviceId, status, fromDate, toDate, personTypeId, userId, consumingNationalCode])


    const downloadExcelExport = () => {
        if (rows) {
             
            readData({ ...globalFilters, p_limit: 0, p_offset: 0 }).then(({ data }) => {
                 
                let csvString = 'نام,کد ملی,گروه,سرویس,خدمت,کسب و کار,آدرس,ثبت کننده,نام خدمت گیرنده,کد ملی خدمت گیرنده,موبایل خدمت گیرنده,نوع کاربر,وضعیت,روش پرداخت,مبلغ,تاریخ,قیمت سرویس,تعدادسرویس,مجموع هزینه ها,شناسه فاکتور\r';

                data.result.result_set.map(row => {
                    csvString += `${row?.name + ' ' + row?.last_name},${row.nationalcode},${row?.groupname?.replace(/,/g, '')},${row?.servicename?.replace(/,/g, '')},${row?.subservicename?.replace(/,/g, '')},${row?.business?.replace(/,/g, '')},${row?.address?.replace(/,/g, '')},${row?.user_name?.replace(/,/g, '')},${row?.consumer_name?.replace(/,/g, '')},${row?.consumer_nationalcode?.replace(/,/g, '')},${row?.consumer_mobile || '-'},${row?.persontitle?.replace(/,/g, '')},${row?.status?.replace(/,/g, '')},${row?.paymenttype?.replace(/,/g, '')},${row?.amount},${row?.register_date ? row?.register_date?.toString().slice(0, 4) + '/' + row?.register_date?.toString().slice(4, 6) + '/' + row?.register_date?.toString().slice(6, 8) : '-'},${row?.price},${row?.cnt_service},${(row?.cnt_service * row?.price)},${row?.order_no}\r`;
                });

                let universalBOM = '\uFEFF';
                let a = window.document.createElement('a');
                a.setAttribute('href', 'data:text/csv;charset=utf-8,' + encodeURIComponent(universalBOM + csvString));
                let fileName = 'report-export.csv';
                a.setAttribute('download', fileName);
                window.document.body.appendChild(a);
                a.click();
                window.document.body.removeChild(a);
            });
        }
    }

    const searchData = () => {
         
        setIsSearched(true);
        setIsAdvanced(true);
        setLoading(true);
        setShowItem(false);

        readData({ ...globalFilters, p_offset: 0, p_limit: pageItems === 0 ? 10 : pageItems }).then(({ data }) => {
             
            setLoading(false)
            setShowItem(true);

            if (data.result && data.result.result_set) {
                setRows(data.result.result_set);
                setCount(data.count);
                calcPages(data);
            }
            else
                setRows([]);
        });
        setIsAdvanced(true);

    }

    const calcPages = data => {
        let calcPages = data.count / (pageItems === 0 ? 10 : pageItems);
        calcPages = calcPages > 1 ? Math.ceil(calcPages) : 1
        let pagesArray = [];
        for (let i = 1; i <= calcPages; i++)
            pagesArray.push(i);
        setPages(pagesArray);
        setCurrentPage(1);
    }

    const changePage = (e, page) => {
         
        e.preventDefault();
        setCurrentPage(page);

        const postedData = {
            p_limit: pageItems === 0 ? 10 : pageItems,
            p_offset: page
        };
        readData({ ...globalFilters, ...postedData }).then(({ data }) => {
             
            if (data.result && data.result.result_set) {
                setRows(data.result.result_set);
            }
        }).catch(err => err.data.errors.map(error => toast.error(error.message)));
    }

    const prevPage = e => {
        e.preventDefault();
        setCurrentPage(currentPage - 1);
        const postedData = {
            p_limit: pageItems === 0 ? 10 : pageItems,
            p_offset: currentPage - 1
        };
        readData({ ...globalFilters, ...postedData }).then(({ data }) => {
            if (data.result && data.result.result_set) {
                setRows(data.result.result_set);
            }
        }).catch(err => err.data.errors.map(error => toast.error(error.message)));
    }

    const nextPage = e => {
        e.preventDefault();
        setCurrentPage(currentPage + 1);
        const postedData = {
            p_limit: pageItems === 0 ? 10 : pageItems,
            p_offset: currentPage + 1
        };
        readData({ ...globalFilters, ...postedData }).then(({ data }) => {
            if (data.result && data.result.result_set) {
                setRows(data.result.result_set);
            }
        }).catch(err => err.data.errors.map(error => toast.error(error.message)));
    }



    const sortReport = () => {
        const sortedProducts = [...rows];
        sortedProducts.sort((a, b) => {
            if (a.last_name < b.last_name) {
                return -1;
            }
            if (a.last_name > b.last_name) {
                return 1;
            }
            return 0;
        });
        setRows(sortedProducts)

    }


    const resetAdvancedSearch = e => {
        e.preventDefault();
        setIsAdvanced(false);

        setNationalCode("")
        setConsumingNationalCode("")
        setFromDate("")
        setToDate("")
        setStatus("")
        setPersonTypeId(0)
        setServiceId(0)
        setGroupId(0)
        setBusinessId(0)
        setUserId(0)

        setRows([]);
        setIsSearched(false)

        readData({ p_offset: 0, p_limit: pageItems === 0 ? 10 : pageItems }).then(({ data }) => {
            if (data.result && data.result.result_set) {
                setRows(data.result.result_set);
                setCount(data.count);
                calcPages(data);
            }
            else
                setRows([]);
        });
    }

    const showMore = (val) => {
         
        if (pageItems !== 0) {
             
            const postData = {
                p_offset: currentPage,
                p_limit: val,
                ...globalFilters
            }
            readData(postData).then(({ data }) => {
                setLoading(false)
                setShowItem(true);
                if (data.result && data.result.result_set) {
                    setRows(data.result.result_set);
                    setCount(data.count);
                    calcPages(data);
                }
                else
                    setRows([]);
            });
        }

    }



    return (
        <div className="row">
            <div className="col-md-3">
                <div className="form-group">
                    <label>کسب و کار</label>
                    {businessId ? <i className="fe fe-x clear-select-btn" onClick={e => setBusinessId(0)}></i> : ''}
                    <ReactSelect noOptionsMessage={e => 'یافت نشد'} placeholder="انتخاب کنید" options={businesses} value={businesses.filter(b => b.value == businessId)} onChange={e => setBusinessId(e.value)} />
                </div>
            </div>
            <div className="col-md-2">
                <div className="form-group">
                    <label>گروه</label>
                    {groupId ? <i className="fe fe-x clear-select-btn" onClick={e => setGroupId(0)}></i> : ''}
                    <ReactSelect noOptionsMessage={e => 'یافت نشد'} placeholder="انتخاب کنید" options={groups} value={groups.filter(b => b.value == groupId)} onChange={e => setGroupId(e.value)} />
                </div>
            </div>
            <div className="col-md-2">
                <div className="form-group">
                    <label>خدمت</label>
                    {serviceId ? <i className="fe fe-x clear-select-btn" onClick={e => setServiceId(0)}></i> : ''}
                    <div className="position-relative" style={{zIndex: 2}}>
                        <ReactSelect noOptionsMessage={e => 'یافت نشد'} placeholder="انتخاب کنید" options={services} value={services.filter(b => b.value == serviceId)} onChange={e => setServiceId(e.value)} />
                    </div>
                </div>
            </div>
            <div className="col-md-3">
                <div className="form-group">
                    <label>کد ملی</label>
                    <InputMask mask="9999999999" className="form-control ltr-input" onChange={e => setNationalCode(e.target.value)} />
                </div>
            </div>
            <div className="col-md-2">
                <div className="form-group">
                    <label>کد ملی استفاده کننده</label>
                    <InputMask mask="9999999999" className="form-control ltr-input" onChange={e => setConsumingNationalCode(e.target.value)} />
                </div>
            </div>
            <div className="col-md-2">
                <div className="form-group">
                    <label>کاربر ثبت کننده</label>
                    {userId ? <i className="fe fe-x clear-select-btn" onClick={e => setUserId(0)}></i> : ''}
                    <ReactSelect noOptionsMessage={e => 'یافت نشد'} placeholder="انتخاب کنید" options={users} value={users.filter(b => b.value == userId)} onChange={e => setUserId(e.value)} />
                </div>
            </div>
            <div className="col-md-3">
                <div className="form-group">
                    <label>نوع پرسنل</label>
                    {personTypeId ? <i className="fe fe-x clear-select-btn" onClick={e => setPersonTypeId(0)}></i> : ''}
                    <ReactSelect noOptionsMessage={e => 'یافت نشد'} placeholder="انتخاب کنید" options={personTypes} value={personTypes.filter(b => b.value == personTypeId)} onChange={e => setPersonTypeId(e.value)} />
                </div>
            </div>
            <div className="col-md-3">
                <div className="form-group">
                    <label>وضعیت پرداخت</label>
                    <select className="form-control" onChange={e => setStatus(e.target.value)}>
                        <option value="">انتخاب کنید</option>
                        <option value="1">پرداخت شده</option>
                        <option value="2">پرداخت نشده</option>
                    </select>
                </div>
            </div>
            <div className="col-md-2">
                        <div className="form-group">
                            <label>از تاریخ</label>
                            {fromDate && <i class="fe fe-x clear-select-btn" onClick={() => setFromDate(null)} style={{left: 25}}></i>}
                            <DatePicker
                                name="fromDate"
                                required
                                locale="fa"
                                shouldHighlightWeekends
                                value={fromDate}
                                onChange={setFromDate}
                                className="form-control"
                                inputPlaceholder='تاریخ  را انتخاب کنید ...'
                            />
                        </div>
                    </div>
                    <div className="col-md-2">
                        <div className="form-group">
                            <label>از تاریخ</label>
                            {toDate && <i class="fe fe-x clear-select-btn" onClick={() => setToDate(null)} style={{left: 25}}></i>}
                            <DatePicker
                                name="toDate"
                                required
                                locale="fa"
                                shouldHighlightWeekends
                                value={toDate}
                                onChange={setToDate}
                                className="form-control"
                                inputPlaceholder='تاریخ  را انتخاب کنید ...'
                            />
                        </div>
                    </div>


            <div className="py-2 col-md-2">
                {showItem && <> <button className="btn btn-primary" onClick={searchData}>جستجو</button>
                    {isAdvanced &&
                        <button className="btn btn-danger mx-2" onClick={resetAdvancedSearch}>حذف فیلتر</button>
                    }
                </>
                }
            </div>

            {isLoading ?
                <div className="lds-facebook mt-4">
                    <div></div>
                    <div></div>
                    <div></div>
                </div > :

                <>

                    {rows.length ? <div className="col-md-12 mt-3">
                        <div className="table-responsive bg-white p-4" style={{ borderRadius: 7 }}>
                            <table className="table custom-table-style table-bordered table-hover mb4">
                                <thead className="table-primary text-center">
                                    <tr>
                                        <th>ردیف</th>
                                        <th>نام</th>
                                        <th>  کد ملی</th>
                                        <th>گروه</th>
                                        <th>سرویس</th>
                                        <th>خدمت</th>
                                        <th>کسب و کار</th>                                     
                                        <th>ثبت کننده</th>
                                        <th>نام خدمت گیرنده</th>
                                        <th>کد ملی خدمت گیرنده</th>
                                        <th>موبایل خدمت گیرنده</th>
                                        <th>وضعیت</th>
                                        <th>روش پرداخت</th>
                                        <th>مبلغ</th>                                        
                                        <th>قیمت سرویس</th>
                                        <th>تعداد سرویس</th>
                                        <th>مجموع هزینه ها</th>
                                        <th>تاریخ</th>
                                        <th>شناسه فاکتور</th>
                                        <th>شناسه دیجی کالا</th>
                                    </tr>
                                </thead>
                                <tbody className="text-center">
                                    {rows.map((row, i) => (
                                        <tr>
                                            <td style={{ width: "1%", textAlign: "center" }}> {((currentPage - 1) * (pageItems === 0 ? 10 : pageItems)) + i + 1}  </td>
                                            <td>{row.name + ' ' + row.last_name}</td>
                                            <td>{row.nationalcode}</td>
                                            <td>{row.groupname}</td>
                                            <td>{row.servicename}</td>
                                            <td>{row.subservicename}</td>
                                            <td>{row.business}</td>                                         
                                            <td>{row.user_name}</td>
                                            <td>{row.consumer_name}</td>
                                            <td>{row.consumer_nationalcode}</td>
                                            <td>{row.consumer_mobile || '-'}</td>
                                            <td>{row.status}</td>
                                            <td>{row.paymenttype || "-"}</td>                                            
                                            <td>{new Intl.NumberFormat('en-IR', { maximumSignificantDigits: 20 }).format(row.amount)}</td>
                                            <td>{new Intl.NumberFormat('en-IR', { maximumSignificantDigits: 20 }).format(row.price)}</td>
                                            <td>{row.cnt_service||"-"}</td>
                                            <td>{new Intl.NumberFormat('en-IR', { maximumSignificantDigits: 20 }).format(row.cnt_service * row.price)}</td>
                                            <td>{row.register_date ? row.register_date.toString().slice(0, 4) + '/' + row.register_date.toString().slice(4, 6) + '/' + row.register_date.toString().slice(6, 8) : '-'}</td>
                                            <td>{row.order_no || '-'}</td>
                                            <td>{row.digikala_id || '-'}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <span>تعداد کل رکورد ها : {count}</span>

                            <div className="d-flex justify-content-between">

                                <Pagination changePage={changePage} currentPage={currentPage} pages={pages} prevPageClick={prevPage} nextPageClick={nextPage} />

                                <div className="form-group d-flex align-items-center  m-0  ">
                                    <label className='mx-2 mt-4' style={{ textWrap: "nowrap" }}>  تعداد نمایش
                                        در صفحه:  </label>
                                    <select className="form-control" onChange={e => setPageItems(e.target.value)}
                                        style={{ width: "25%" }}  >
                                        <option value="10">  10 </option>
                                        <option value="20">  20 </option>
                                        <option value="50">  50 </option>
                                        <option value="100">  100 </option>
                                    </select>
                                </div>

                            </div>

                            <button className={count > 10 ? 'btn btn-success mt-4' : 'btn btn-success mt-4'} onClick={downloadExcelExport}>دانلود خروجی اکسل</button>


                        </div>
                    </div> : isSearched ? <div className="col-md-12 mt-2"><div className="alert alert-primary"><p>داده ای جهت نمایش یافت نشد</p></div></div> : <div className="col-md-12 mt-2"><div className="alert alert-info"><p>جهت دریافت اطلاعات پس از اعمال فیلتر های مورد نظر بر روی جستجو کلیک کنید</p></div></div>
                    }

                </>
            }
        </div >
    );
}

export default Transactions;